import React from "react";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import { Card, Chip, InputAdornment } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import { useWatch } from "react-hook-form";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper";
import { FormGroupWithInlineButtonsTC } from "../../../../components/Forms/FormGroupWithInlineButtonsTC";
import FormText from "../../../../components/Forms/FormText";
import { InputValidation } from "../../../../components/Forms/InputValidation";
import { ContextualValue } from "../../../../components/Forms/ContextualValue";
import { arrangementCreditCostOptions } from "../../../Upsell/modernTS/JUI/Arrangements/arrangementCreditCostSelectOptions";

export default function General() {
  let maximum_per_ticket: number | string = useWatch({ name: "maximum_per_ticket" });
  if (typeof maximum_per_ticket === "string") {
    maximum_per_ticket = Number.parseInt(maximum_per_ticket);
  } else if (maximum_per_ticket == null) {
    maximum_per_ticket = 0;
  }
  let maximum_order_rounds: number | string = useWatch({ name: "maximum_order_rounds" });
  if (typeof maximum_order_rounds === "string") {
    maximum_order_rounds = Number.parseInt(maximum_order_rounds);
  } else if (maximum_order_rounds == null) {
    maximum_order_rounds = 0;
  }

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <FormTextTC name={"name"} tDefault={"Name"} tKey={"arrangement-groups.name"} />
          <FormSelectTC
            defaultValue={"1"}
            name={"credit_cost"}
            options={arrangementCreditCostOptions()}
            tDefault={"Credit cost"}
            tKey={"arrangements.form.groups.credit_cost"}
          />
        </CardBody>
      </Card>
      <Card sx={{ mt: 2 }}>
        <CardBody>
          <h4>
            <TranslationWrapper tDefault={"Arrangement group rules"} tKey={"arrangements.form.groups.heading.rules"} />
          </h4>
          <ul>
            <li>All the rules below apply per cover.</li>
            <li>Any products in this group will count towards the rule.</li>
            <li>
              If a product belongs to more than one group of rules, all rules must pass for the product to be orderable.
            </li>
          </ul>
          <FormGroupWithInlineButtonsTC
            formField={
              <FormText
                defaultValue={0}
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>Products per dining session</InputAdornment>,
                    startAdornment:
                      maximum_per_ticket === 0 ? (
                        <InputAdornment position={"start"}>
                          <Chip label={<TranslationWrapper tDefault={"No limit"} tKey={"No limit"} />} />
                        </InputAdornment>
                      ) : null,
                  },
                }}
                name={"maximum_per_ticket"}
                rules={{
                  ...InputValidation.REQUIRED,
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: getTranslation("The value must not be negative"),
                  },
                  pattern: {
                    ...InputValidation.REGEX_VALIDATE_WHOLE_NUMBER,
                  },
                }}
              />
            }
            tDefault={"Limit the number of products allowed to order per dining session"}
            tKey={"arrangements.form.groups.rules.max_per_ticket"}
          >
            <ContextualValue targetValue={0}>
              <TranslationWrapper tDefault={"Default"} tKey={"Default"} />
            </ContextualValue>
          </FormGroupWithInlineButtonsTC>
          <FormGroupWithInlineButtonsTC
            formField={
              <FormText
                defaultValue={0}
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>Rounds</InputAdornment>,
                    startAdornment:
                      maximum_order_rounds === 0 ? (
                        <InputAdornment position={"start"}>
                          <Chip label={<TranslationWrapper tDefault={"No limit"} tKey={"No limit"} />} />
                        </InputAdornment>
                      ) : null,
                  },
                }}
                name={"maximum_order_rounds"}
                rules={{
                  ...InputValidation.REQUIRED,
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: getTranslation("The value must not be negative"),
                  },
                  pattern: {
                    ...InputValidation.REGEX_VALIDATE_WHOLE_NUMBER,
                  },
                }}
              />
            }
            tDefault={"Limit the number of rounds, products can be ordered"}
            tKey={"arrangements.form.groups.rules.max_rounds"}
          >
            <ContextualValue targetValue={0}>
              <TranslationWrapper tDefault={"Default"} tKey={"Default"} />
            </ContextualValue>
          </FormGroupWithInlineButtonsTC>

          <FormGroupWithInlineButtonsTC
            formField={
              <FormText
                defaultValue={0}
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>Products</InputAdornment>,
                    startAdornment:
                      maximum_order_rounds === 0 ? (
                        <InputAdornment position={"start"}>
                          <Chip label={<TranslationWrapper tDefault={"No limit"} tKey={"No limit"} />} />
                        </InputAdornment>
                      ) : null,
                  },
                }}
                name={"max_per_round_per_cover"}
                rules={{
                  ...InputValidation.REQUIRED,
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: getTranslation("The value must not be negative"),
                  },
                  pattern: {
                    ...InputValidation.REGEX_VALIDATE_WHOLE_NUMBER,
                  },
                }}
              />
            }
            tDefault={"Limit the number of products which can be ordered per round per cover"}
            tKey={"arrangements.form.groups.rules.max_per_round_per_cover"}
          >
            <ContextualValue targetValue={0}>
              <TranslationWrapper tDefault={"Default"} tKey={"Default"} />
            </ContextualValue>
          </FormGroupWithInlineButtonsTC>
        </CardBody>
      </Card>
    </>
  );
}
